import { ImmutableObject } from 'ia-react-core/~/interfaces/ImmutableObject';
import mergeObject from './#mergeObject';

/**
 * @visibleName merge
 * @since 0.19.2
 * @component
 */
export default function merge<Type extends object = object>(object: Type, ...sources: object[]): Type {
  // Duck checking immutable.js
  if (object && 'mergeDeep' in object) {
    return (object as unknown as ImmutableObject).mergeDeep(...sources as {[index: string]: unknown}[]) as Type;
  }

  return sources.reduce<Type>((result, source) => (
    mergeObject<Type, Type>(result, source as Type) as Type
  ), object) as unknown as Type;
}
